import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import PrepareDataTable from "./PrepareDataTable";
import { ClientUsersListContainer, Title } from "./ClientUsersList.styled";
import "./ClientUsersList.scss";

/**
 * Client Platform Users List,
 * Path - /administration/clientUsers
 * @component
 */
const ClientUsersList = (props) => {
  const { t, columnList } = props;

  return (
    <ClientUsersListContainer className="client-users-list">
      <Title>{t("ADMINISTRATION_CLIENT_USERS_TITLE")}</Title>
      <PrepareDataTable columnList={columnList} />
    </ClientUsersListContainer>
  );
};

ClientUsersList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

ClientUsersList.defaultProps = {
  columnList: [],
};

export default withTranslation()(ClientUsersList);
